import React from 'react';
import { Box, Typography } from '@mui/material';

export default function AllShipments() {
  return <Box><Typography variant="h4">All Shipments</Typography></Box>;
}
